export default __webpack_public_path__ + "44b92d6a9fc6ff9d77407b94405461be.jpg";